

<app-overlay-loader *ngIf="loader && !quizloader"></app-overlay-loader>
<app-overlay-loader *ngIf="quizloader"></app-overlay-loader>
<div class="selfAssessmentParent">
    <div class="useractivityParent">
        <div class="useractivity_left_parent">
            <div class="useractivity_table">
                <div class="dropdown-wrapper">
                    <div class="dropdown-wrapper-parent">
                        <div class="course_filter flex flex-col justify-content-end" *ngIf="courses?.length > 0">
                            <span>Course</span>
                            <p-dropdown [options]="courses" [(ngModel)]="selectedCourse" optionLabel="courseName" optionValue="courseID" (onChange)="filterByCourse()"></p-dropdown>
                        </div>
        
                        <div class="course_filter flex flex-col justify-content-end" *ngIf="assesmentsList?.length > 0">
                            <span>Assessment</span>
                            <p-dropdown [options]="assesmentsList" [(ngModel)]="selectAssessment" optionLabel="name" optionValue="assessment_id" (onChange)="getAssesmentsQuizes()"></p-dropdown>
                        </div>
                    </div>
                    <div class="reset-button-wrapper">
                        <p-button 
                            label="Reset Self Assessment" 
                            icon="pi pi-refresh" 
                            styleClass="p-button-outlined p-button-danger"
                            (onClick)="resetSelfAssessment()"
                            [disabled]="!selectAssessment || quizloader">
                        </p-button>
                    </div>
                </div>
                
                
                <p-table *ngIf="!quizloader" id="userActivityTable" #dt [value]="prevQuizData" [scrollable]="true" scrollHeight="400px" (onLazyLoad)="loadCustomers($event)" [paginator]="true" [showCurrentPageReport]="true" currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries" [loading]="loading" [rows]="selectedNum" [totalRecords]="tests?.length" [loading]="loading" [globalFilterFields]="['quiz_meta.quizTitle','quiz_meta.quizMode','quiz_meta.quizStatus']" dataKey="name">
                    <ng-template pTemplate="caption" class="table_top_bar">
                        <div class="p-d-flex p-ai-center p-jc-between">
                            <h5 class="p-m-0">
                            </h5>
                            <div class="filters flex align-items-center">
                                <div class="filter_by">
                                    <span>Filter by Status</span>
                                    <p-dropdown [options]="status" [(ngModel)]="selectedStatus" (onChange)="filterByStatus()"></p-dropdown>
                                </div>
                                <!-- <span class="p-input-icon-left mr-3">
                                    <i class="pi pi-search"></i>
                                    <input pInputText type="text" (input)="dt.filterGlobal($event.target.value, 'contains')" placeholder="Search..." />
                                </span> -->
                            </div>
                        </div>
                    </ng-template>

                    <ng-template pTemplate="header" class="table_header" styleClass="myTable" class="some-custom-class-name" pResizableColumn>
                        <tr>
                            <th pSortableColumn="id" class="id_prevTest_table" [ngStyle]="{'width':'120px', 'min-width':'120px'}">Block ID</th>
                            <th pSortableColumn="quiz_meta.quizDate" [ngStyle]="{'width':'200px', 'min-width':'200px'}">DATE <p-sortIcon field="quiz_meta.quizDate"></p-sortIcon></th>
                            <th pSortableColumn="quiz_meta.quizDate" [ngStyle]="{'width':'200px', 'min-width':'200px'}">TIME ALLOTED <p-sortIcon field="quiz_meta.quizDate"></p-sortIcon></th>
                            <th pSortableColumn="quiz_meta.quizDate" [ngStyle]="{'width':'200px', 'min-width':'200px'}">TIME REMAINING <p-sortIcon field="quiz_meta.quizDate"></p-sortIcon></th>
                            <th pSortableColumn="quiz_meta.quizMode" [ngStyle]="{'width':'100px', 'min-width':'100px'}">MODE <p-sortIcon field="quiz_meta.quizMode"></p-sortIcon></th>
                            <th pSortableColumn="quiz_meta.quizStatus" [ngStyle]="{'width':'100px', 'min-width':'100px'}">STATUS <p-sortIcon field="quiz_meta.quizStatus"></p-sortIcon></th>
                           <th pSortableColumn="actions" class="pr-5 mr-5" [ngStyle]="{'width':'280px', 'min-width':'280px'}">ACTIONS</th>
                        </tr>
                    </ng-template>

                    <ng-template pTemplate="body" let-quiz let-i="rowIndex" class="table_body">
                        <tr [ngClass]="{'disable': !quiz.quiz_meta.visibility}">
                           
                            <td class="id_prevTest_table" [ngStyle]="{'width':'120px', 'min-width':'120px'}">Block - # {{i+1}}</td>
                            <td class="date" [ngStyle]="{'width':'200px', 'min-width':'200px'}">{{currentDate}}</td>
                            <td class="status" [ngStyle]="{'width':'200px', 'min-width':'200px'}">{{quiz.quiz_meta.quizTotalTime}}</td>
                            <td class="status" [ngStyle]="{'width':'200px', 'min-width':'200px'}">{{ quiz.quiz_meta.quizStatus == 'completed' ? '-' : quiz.quiz_meta.quizTimeRemaining}}</td>
                            <td class="mode" [ngStyle]="{'width':'100px', 'min-width':'100px'}">{{(quiz.quiz_meta.quizMode) ? quiz.quiz_meta.quizMode:'exam'}}</td>
                           
                            <td class="status" [ngStyle]="{'width':'100px', 'min-width':'100px'}">{{(quiz.quiz_meta.quizStatus)?quiz.quiz_meta.quizStatus:'-'}}</td>
                            <td class="actions pr-5" [ngStyle]="{'width':'280px', 'min-width':'280px'}">
                                <div class="action_wrapper">
                                    
                                    <div class="resume_action" (click)="getQuiz(quiz.quiz_id)" *ngIf="quiz.quiz_meta.quizStatus != 'suspended' && quiz.quiz_meta.quizStatus != 'completed' &&  userMembership" ><i class="pi pi-play"></i>
                                        <div>Start</div>
                                    </div>
                                    <div class="resume_action" (click)="resumeQuiz(quiz.quiz_id, quiz.quiz_meta.quizScore)" *ngIf="demo == -1"><i class="pi pi-caret-right"></i>
                                        <div>Resume</div>
                                    </div>
                                    <div class="resume_action" (click)="resumeQuiz(quiz.quiz_id, quiz.quiz_meta.quizScore)" *ngIf="quiz.quiz_meta.quizStatus == 'suspended' && userMembership"><i class="pi pi-caret-right"></i>
                                        <div>Resume</div>
                                    </div>
                                    <div [ngClass]="{'disable': !quiz.quiz_meta.quizStatus}" class="results_action" (click)="gotoPerformanceScreen(1, quiz.quiz_id, quiz.quiz_meta.quizTitle, quiz.quiz_meta.quizScore, quiz.quiz_meta.quizStatus)"><i class="pi pi-file"></i>
                                        <div>Results</div>
                                    </div>
                                    <div  [ngClass]="{'disable': !quiz.quiz_meta.quizStatus}"  class="analysis_action" (click)="gotoPerformanceScreen(2, quiz.quiz_id, quiz.quiz_meta.quizTitle,  quiz.quiz_meta.quizScore, quiz.quiz_meta.quizStatus)"><i class="pi pi-chart-bar"></i>
                                        <div>Analysis</div>
                                    </div>
                                </div>
                            </td>
                        </tr>
                    </ng-template>

                    <ng-template pTemplate="emptymessage">
                        <tr>
                            <td colspan="7" class="text-center empty-message">
                                <div class="empty-state">
                                    <i class="pi pi-inbox empty-icon"></i>
                                    <h3>No Blocks Available</h3>
                                    <p>There are currently no quiz blocks available for this assessment.</p>
                                </div>
                            </td>
                        </tr>
                    </ng-template>
                </p-table>
            </div>
        </div>
    </div>
</div>

<p-dialog header="" styleClass="copyDialog" [(visible)]="displayCopy" position="center" [modal]="false" [baseZIndex]="10000" [draggable]="false">
    <span>Quiz ID Copied!</span>
</p-dialog>

<p-dialog header="Confirmation" [(visible)]="deleteModal" [modal]="true" [closable]="false" [style]="{width: '330px'}" [baseZIndex]="10000" [draggable]="false" [resizable]="false">
    <p class="p-m-0">Are you sure you want to delete this quiz?</p>
    <ng-template pTemplate="footer">
        <p-button icon="pi pi-check" (click)="deleteQuiz()" label="Yes" class="p-button-text"></p-button>
        <p-button icon="pi pi-times" (click)="deleteModal=false" label="No"></p-button>
    </ng-template>
</p-dialog>

<!-- New Test Confirmation Modal -->
<p-dialog header="Confirm" [(visible)]="showNewTestModal" [modal]="true" [closable]="false" [style]="{width: '400px'}" [baseZIndex]="10000" [draggable]="false" [resizable]="false" styleClass="new-test-modal">
    <div class="modal-content">
        <p>Do you want to start new test ?</p>
    </div>
    <ng-template pTemplate="footer">
        <div class="modal-buttons">
            <p-button label="NO" (click)="closeNewTestModal()" styleClass="p-button-outlined"></p-button>
            <p-button label="YES" (click)="startNextQuiz()" styleClass="p-button-primary"></p-button>
        </div>
    </ng-template>
</p-dialog>
